import { useReducer } from "react";

function patchReducer<T>(state: T, patch: Partial<T>): T {
    return Object.assign({}, state, patch);
}
export function usePatchReducer<T>(initState: T): [T, React.Dispatch<Partial<T>>] {
    return useReducer<((state: T, patch: Partial<T>) => T)>(patchReducer, initState) as [T, React.Dispatch<Partial<T>>];
}
